<template>
  <select :class="className">
    <option value="/">Select Option One</option>
    <option value="/">Select Option Two</option>
    <option value="/">Select Option Three</option>
    <option value="/">Select Option Four</option>
    <option value="/">Select Option Five</option>
    <option value="/">Select Option Six</option>
  </select>
</template>

<script>
export default {
  name: 'FormSelect',
  props: {
    rounded: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: false
    },
    tint: {
      type: Boolean,
      default: false
    },
    semi: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className() {
      return `${(this.rounded && 'select--rounded') || ''} ${(this.shadow &&
        'select--shadow') ||
        ''} ${(this.tint && 'select--tint') || ''} ${(this.semi &&
        'select--semi') ||
        ''} ${(this.small && 'select--small') || ''}`
    }
  }
}
</script>

<style lang="postcss">
select {
  @apply cursor-pointer p-4 pr-16 my-8 w-full border-none rounded-none appearance-none font-normal text-lg text-body bg-white bg-no-repeat;
  background-image: url('../assets/svg/form-select-icon.svg');
  background-position: center right 1.5rem;
}
select:focus {
  @apply outline-none;
}
select::-ms-expand {
  display: none;
}
.select--shadow {
  @apply shadow;
}
.select--rounded {
  @apply rounded;
}
.select--tint {
  @apply bg-primary-lighter;
}
.select--semi {
  @apply font-semibold;
}
.select--small {
  @apply w-full;
}
@screen lg {
  .select--small {
    @apply w-2/3;
  }
}
</style>
